module.exports = __webpack_public_path__ + "static/media/registration_confirmation_706x470_v2.8a680c19.svg";